import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class NotFoundError extends EluveError {
  static override readonly errorName = 'NotFoundError';
  readonly logLevel: LogLevel = 'error';

  constructor(message = 'Not Found', args?: EluveErrorArgs) {
    super(message, args);
  }
}
